<template>
    <div>
        <v-card flat class="pa-1">
            <v-toolbar flat color="#FFF" short>
                <v-toolbar-title>Configurações do Sistema</v-toolbar-title>
            </v-toolbar>
            <v-tabs centered>
                <v-tab>
                    <v-icon left>mdi-link-variant</v-icon>
                    Instância Parceira
                </v-tab>

                <v-tab-item class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-instancia-parceira></cfg-instancia-parceira>
                        </v-card-text>
                    </v-card>
                </v-tab-item>

                <v-tab>
                    <v-icon left>mdi-lock-clock</v-icon>
                    Bloqueio de Acesso
                </v-tab>

                <v-tab-item class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-bloqueio-acesso></cfg-bloqueio-acesso>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </div>
</template>
<script>
    import CfgInstanciaParceira from '../cfg/CfgInstanciaParceira'
    import CfgBloqueioAcesso from '../cfg/CfgBloqueioAcesso'

    export default {
        components: {
            CfgInstanciaParceira,
            CfgBloqueioAcesso
        },
        name: "Cfg",

        created() {
            this.Helpers.verificarToken();
        },
    }
</script>
<style scoped>
</style>
